import { ProductsSyncContainer } from '@/modules/AkeneoSync';

export const ProductsSync = (): JSX.Element => <ProductsSyncContainer />;

export default ProductsSync;
